import { isObject } from "@visactor/vutils";

import { BaseRenderContributionTime } from "../../../../common/enums";

import { DefaultBaseBackgroundRenderContribution } from "./base-contribution-render";

import { boundsAllocate } from "../../../../allocator/bounds-allocate";

import { getTextBounds } from "../../../../graphic/bounds";

import { createRectPath } from "../../../../common/shape/rect";

export class DefaultTextBackgroundRenderContribution extends DefaultBaseBackgroundRenderContribution {
    constructor() {
        super(...arguments), this.time = BaseRenderContributionTime.beforeFillStroke;
    }
    drawShape(graphic, context, x, y, doFill, doStroke, fVisible, sVisible, graphicAttribute, drawContext, fillCb, strokeCb) {
        var _a, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        const {backgroundOpacity: backgroundOpacity = graphicAttribute.backgroundOpacity, opacity: opacity = graphicAttribute.opacity, backgroundMode: backgroundMode = graphicAttribute.backgroundMode, backgroundFit: backgroundFit = graphicAttribute.backgroundFit, backgroundKeepAspectRatio: backgroundKeepAspectRatio = graphicAttribute.backgroundKeepAspectRatio, backgroundScale: backgroundScale = graphicAttribute.backgroundScale, backgroundOffsetX: backgroundOffsetX = graphicAttribute.backgroundOffsetX, backgroundOffsetY: backgroundOffsetY = graphicAttribute.backgroundOffsetY, backgroundPosition: backgroundPosition = graphicAttribute.backgroundPosition, backgroundClip: backgroundClip = graphicAttribute.backgroundClip, backgroundCornerRadius: backgroundCornerRadius = graphicAttribute.backgroundCornerRadius} = graphic.attribute;
        let matrix, {background: background} = graphic.attribute;
        if (!background) return;
        const restore = () => {
            "richtext" === graphic.type && (context.restore(), context.save(), matrix && context.setTransformFromMatrix(matrix, !0, 1));
        };
        let b;
        "richtext" === graphic.type && (matrix = context.currentMatrix.clone(), context.restore(), 
        context.save(), context.setTransformForCurrent());
        const backgroundConfig = isObject(background) && background.background ? background : null, onlyTranslate = graphic.transMatrix.onlyTranslate();
        if (backgroundConfig) {
            const _b = graphic.AABBBounds, x = (null !== (_a = backgroundConfig.x) && void 0 !== _a ? _a : _b.x1) + (null !== (_c = backgroundConfig.dx) && void 0 !== _c ? _c : 0), y = (null !== (_d = backgroundConfig.y) && void 0 !== _d ? _d : _b.y1) + (null !== (_e = backgroundConfig.dy) && void 0 !== _e ? _e : 0), w = null !== (_f = backgroundConfig.width) && void 0 !== _f ? _f : _b.width(), h = null !== (_g = backgroundConfig.height) && void 0 !== _g ? _g : _b.height();
            if (b = boundsAllocate.allocate(x, y, x + w, y + h), background = backgroundConfig.background, 
            !onlyTranslate) {
                const w = b.width(), h = b.height();
                b.set((null !== (_h = backgroundConfig.x) && void 0 !== _h ? _h : 0) + (null !== (_j = backgroundConfig.dx) && void 0 !== _j ? _j : 0), (null !== (_k = backgroundConfig.y) && void 0 !== _k ? _k : 0) + (null !== (_l = backgroundConfig.dy) && void 0 !== _l ? _l : 0), w, h);
            }
        } else b = graphic.AABBBounds, onlyTranslate || (b = getTextBounds(Object.assign(Object.assign({}, graphic.attribute), {
            angle: 0,
            scaleX: 1,
            scaleY: 1,
            x: 0,
            y: 0,
            dx: 0,
            dy: 0
        })).clone());
        if (graphic.backgroundImg && graphic.resources) {
            const res = graphic.resources.get(background);
            if (!res || "success" !== res.state || !res.data) return void restore();
            context.highPerformanceSave(), onlyTranslate && context.setTransformFromMatrix(graphic.parent.globalTransMatrix, !0), 
            context.globalAlpha = backgroundOpacity * opacity, backgroundClip && (context.beginPath(), 
            backgroundCornerRadius ? createRectPath(context, b.x1, b.y1, b.width(), b.height(), backgroundCornerRadius, !0) : context.rect(b.x1, b.y1, b.width(), b.height()), 
            context.clip()), this.doDrawImage(context, res.data, b, {
                backgroundMode: backgroundMode,
                backgroundFit: backgroundFit,
                backgroundKeepAspectRatio: backgroundKeepAspectRatio,
                backgroundScale: backgroundScale,
                backgroundOffsetX: backgroundOffsetX,
                backgroundOffsetY: backgroundOffsetY,
                backgroundPosition: backgroundPosition
            }), context.highPerformanceRestore(), context.setTransformForCurrent();
        } else context.highPerformanceSave(), context.setCommonStyle(graphic, graphic.attribute, x, y, graphicAttribute), 
        context.globalAlpha = backgroundOpacity * opacity, context.fillStyle = background, 
        backgroundCornerRadius ? (createRectPath(context, b.x1, b.y1, b.width(), b.height(), backgroundCornerRadius, !0), 
        context.fill()) : context.fillRect(b.x1, b.y1, b.width(), b.height()), context.highPerformanceRestore();
        backgroundConfig && boundsAllocate.free(b), restore();
    }
}

export const defaultTextBackgroundRenderContribution = new DefaultTextBackgroundRenderContribution;
//# sourceMappingURL=text-contribution-render.js.map
